import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EnvironmentService} from '../../../../common/services/environment-service';
import {detailsExpand} from '../../../../common';

enum Controls {
  ClaimOverrideIndicator1 = 'claimOverrideIndicator1',
}

interface DialogData {
  isAllowedToEdit: boolean;
  indicatorValues: {
    [key: string]: boolean;
  };
}

@Component({
  selector: 'app-activity-history-dialog',
  templateUrl: './encounter-override-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss'],
  animations: [detailsExpand]
})
export class EncounterOverrideDialogComponent {
  readonly controls = Controls;
  readonly overrideIndicatorNames: { [key: string]: string } = {};
  formGroup: FormGroup;
  heading = 'Encounter Override Indicators';

  @Output() updateIndicatorsStatus: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private environmentService: EnvironmentService,
    public dialogRef: MatDialogRef<EncounterOverrideDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.overrideIndicatorNames = this.environmentService.getEncounterOverrideIndicatorNames();

    this.formGroup = this.formBuilder.group({
      [Controls.ClaimOverrideIndicator1]: new FormControl({
        value: this.data[Controls.ClaimOverrideIndicator1],
        disabled: this.data?.isAllowedToEdit !== undefined && !this.data?.isAllowedToEdit
      }),
    });
  }

  onSubmitClick(): void {
    this.dialogRef.close({
      [Controls.ClaimOverrideIndicator1]: this.formGroup.get(Controls.ClaimOverrideIndicator1).value,
    });
  }

  onCancelDialogClick(): void {
    this.dialogRef.close(null);
  }
}
